import { Link } from 'react-router-dom';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import FlexBox from './FlexBox';
import Icon from './Icon';
import ALink from './ALink';
import { Icon as Muicon } from '@mui/material';

const UIText = styled.h4`
  ${({ theme }) => theme.typography.UIText}
  margin : 0px;
  color: ${({ theme }) => theme.color.textSecondary};
  font-weight: bold;
`;

type BreadcrumbItemProps = {
  name: string;
  link?: string;
  id?: string;
  node?: string;
  icon?: string;
  iconBg?: string;
  iconShadow?: string;
};

type BreadcrumbProps = {
  path: Array<BreadcrumbItemProps>;
};

const Breadcrumb = ({
  path,
  ...props
}: BreadcrumbProps & React.HTMLProps<HTMLDivElement>): JSX.Element => (
  <FlexBox>
    <Link to="/explore" style={{ textDecoration: 'none', color: '#FFFFFF' }}>
      <Icon name="home" />
    </Link>
    {path.map((page: BreadcrumbItemProps, index: number) => (
      <Fragment key={`breaddrumb-item-${index}`}>
        {/* <UIText>&raquo;</UIText> */}
        <Icon name="arrow-right" />
        {page.icon && (
          <Muicon
            sx={{
              color: 'white',
              mr: 1,
              padding: '6px',
              background: page.iconBg,
              boxShadow: page.iconShadow,
              borderRadius: '100px',
              fontSize: '18px',
            }}>
            {page.icon}
          </Muicon>
        )}
        {index < path.length - 1 ? (
          <Link
            to={page.link || ''}
            state={{ id: page?.id, node: page?.node }}
            style={{ textDecoration: 'none' }}>
            <ALink>{page.name}</ALink>
          </Link>
        ) : (
          <UIText>{page.name}</UIText>
        )}
      </Fragment>
    ))}
  </FlexBox>
);

export default Breadcrumb;
